import { PAGE_TYPE } from '../page-types'
import type { RouteLocationNormalized } from 'vue-router'
/* ------- MICROFRONT - MON COMPTE ------- */

export const accountRoutes = [
  {
    path: '/account',
    name: 'account',
    redirect: { name: 'user' },
  },
  {
    path: '/account/menu',
    name: 'user-menu',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => ({
      microFrontName: 'my-account',
      viewName: 'menu',
    }),
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/user',
    name: 'user',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'user',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/technical-sales',
    name: 'techsales',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'techsales',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/my-shopping-lists',
    name: 'purchase-orders',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'purchase-orders',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/change-partner',
    name: 'switch-profile',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'switch-profile',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/wishlist',
    name: 'wishlist',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'wishlist',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/wishlists',
    name: 'wishlists',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'wishlists',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/wishlist/:wishlistId',
    name: 'wishlist-details',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: (route: RouteLocationNormalized) => {
      return {
        microFrontName: 'my-account',
        viewName: 'wishlist-details',
        wishlistId: route.params.wishlistId,
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/recommended-list/:recommendedListId',
    name: 'recommended-list-details',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: (route: RouteLocationNormalized) => {
      return {
        microFrontName: 'my-account',
        viewName: 'recommended-list-details',
        recommendedListId: route.params.recommendedListId,
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/orders',
    name: 'orders-agri',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'orders-agri',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/order/:orderId',
    name: 'order-detail-agri',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: (route: RouteLocationNormalized) => {
      return {
        microFrontName: 'my-account',
        viewName: 'order-detail',
        orderId: route.params.orderId,
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/profile',
    name: 'profile',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'profile',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/associated-accounts',
    name: 'client-associated-accounts',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'client-associated-accounts',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/contract',
    name: 'sales-agreement',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'sales-agreement',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/account/notifications',
    name: 'subscriptions',
    component: () => import('@b2ag/micro-front-my-account/app'),
    props: () => {
      return {
        microFrontName: 'my-account',
        viewName: 'subscriptions',
      }
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.ACCOUNT,
    },
  },
  {
    path: '/shopping-list/:purchaseOrderId',
    name: 'purchase-order-details',
    component: () => import('@b2ag/micro-front-purchase-order/app'),
    props: (route: RouteLocationNormalized) => ({
      microFrontName: 'purchase-order',
      viewName: 'purchase-order-details',
      purchaseOrderId: route.params.purchaseOrderId,
    }),
    meta: {
      private: true,
    },
  },
]
